import { useEffect, useRef } from 'react';

export type HandleSetCheckedItemsProps = {
  [id: string]: boolean;
};
export type CheckedMap = Record<string, boolean>;
export interface DataRecord extends Record<any, any> {
  id: string;
}
export const DEFAULT_CHECKED_ITEMS = {};

export const hasNewIds = (
  prev: Array<{ id: string }>,
  current: Array<{ id: string }>,
) => {
  const prevIds = new Set(prev.map(({ id }) => id));
  const currentIds = new Set(current.map(({ id }) => id));
  return !currentIds.isSubsetOf(prevIds);
};

export const defaultColumnPredicate = <ItemsType extends DataRecord>(
  _columnName: keyof ItemsType,
  columnValue: string | number,
) => columnValue;

export const selectAllIds = (items: any[]) => {
  return items.reduce((prev, { id }) => {
    return {
      ...prev,
      [id]: true,
    };
  }, {});
};

export const handleSetCheckedItems = (
  checkedItemsMap: CheckedMap,
  onCheckedItems: ((m: CheckedMap) => void) | undefined,
  setCheckedItems: (m: CheckedMap) => void,
) => {
  if (onCheckedItems) onCheckedItems(checkedItemsMap);
  else setCheckedItems(checkedItemsMap);
};

export const useGetPrevious = (value: any) => {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
};

export const isAllChecked = <T extends { id: string }>(
  pagedItems: T[],
  checkedTableItems: Readonly<CheckedMap>,
) => {
  return pagedItems.every((elem) => elem.id in checkedTableItems);
};

export const removePagedItemChecks = (
  currentCheckedItems: Readonly<CheckedMap>,
  pagedItems: ReadonlyArray<{ id: string }>,
) => {
  const prevCheckItems = { ...currentCheckedItems };
  pagedItems.forEach(({ id }) => {
    delete prevCheckItems[id];
  });
  return prevCheckItems;
};
